<template>
    <div>
        <h1 class="pt-2 text-sm">
            {{$t('form.tchat.reparation_en_autonomie')}}
        </h1>
        <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
            <template v-for="(message, index) in messages">
                <div v-if="message.show" :key="index">
                    <other-message
                    v-if="message.bot"
                    :avatar="avatarBot"
                    class="ml-2"
                    >
                        <span v-html="message.content"></span>
                    </other-message>
                    <my-message
                    :test-id="'my-message-' + message.step + '-' + message.stepIndex"
                    v-if="!message.bot"
                    @click="message.callbackFunc ? message.callbackFunc(message) : callbackMessage(message)"
                    >
                        <span v-html="message.content"></span>
                    </my-message>
                </div>
            </template>
            <template v-if="botTyping">
                <other-message
                :avatar="avatarBot"
                class="ml-2"
                >
                    <div class="typing-loader"></div>
                </other-message>
            </template>
            <div @click="resetTchat" class="duration-200 opacity-50 cursor-pointer fas fa-redo hover:opacity-100"></div>
        </div>
    </div>
</template>



<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'

import MyMessage from './Components/MyMessageBubble.vue'
import OtherMessage from './Components/BotMessageBubble.vue'

export default {
    name: 'own-tchat',
    extends: FormCardExtension,

    components: {
        MyMessage,
        OtherMessage
    },

    watch: {
        messages: {
            deep: true,
            handler() {
                this.displayMessages()
            }
        },

        lastResponse(value) {
            this.lastResponse.groupId = this.makeId()
            value.reponses.forEach((response, index) => {
                value.reponses[index].step = this.responseStep
                value.reponses[index].stepIndex = index
            })
            if (Object.keys(value.solution).length > 0) {
                this.setMessage(value.solution.texte)
                this.setMessage(this.$t('form.tchat.cette_solution_vous_a_t_elle_aide'))
                this.setMessage(this.$t('form.tchat.oui'), 0, false, this.solutionFoundCloseForm, this.responseStep, 0)
                this.setMessage(this.$t('form.tchat.non'), 0, false, this.solutionNotFound, this.responseStep, 1)
            } else {
                if (value.question.length > 0) {
                    this.setQuestion(value.question[0])
                    this.setReponses(value.reponses, value.question[0])
                } else {
                    this.lastMessagesAndEnd()
                }
            }
            this.responseStep++
        }
    },
    
    data() {
        return {
            avatarBot: "https://i.ibb.co/qWjPsks/avatar-icon-png-105-images-in-collection-page-3-avatarpng-512-512.png",
            messages: [],
            botTyping: false,
            botDelay: 1500,
            lastResponse: null,
            responseStep: 0,
        }
    },

    methods: {
        init() {
            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                let selectedData = this.$formTool.getFormData(this.$options.name)
                this.messages = selectedData.messages
                this.messages.forEach((message, index) => {
                    this.messages[index].delay = 0
                })
                this.nextBlock = selectedData.next
                this.selected = JSON.parse(JSON.stringify(selectedData))
            } else {
                this.initTchat()
            }
        },

        end(callbackData) {
            let callback = {
                next: callbackData.next,
                messages: this.messages
            }
            this.$formTool.addFormData(this.$options.name, callback)
            this.nextBlock = callbackData.next
            this.selected = JSON.parse(JSON.stringify(callback))
        },


        async initTchat() {
            let response = await this.getQuestion()
            this.lastResponse = response.data.posts.post
            this.botTyping = false
            this.messages = []
            this.setMessage(this.$t('form.tchat.bienvenue_sur_notre_assistance'), 0)
            this.setMessage(this.$t('form.tchat.ensemble_nous_allons_identifier_votre_panne'))
        },

        makeId() {
            let result = ''
            let length = 20
            let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
            let charactersLength = characters.length

            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength))
            }
            return result;
        },

        displayMessages() {
            this.messages.forEach(message => {
                if (!message.show && !this.botTyping) {
                    this.botTyping = true
                    setTimeout(() => {
                        message.show = true
                        this.botTyping = null
                        window.scrollTo(0, document.body.scrollHeight - 100);
                    }, message.delay)
                }
            });
        },

        async getQuestion(questionId, responseId) {
            let formObject = {
                id_bdc: this.$formTool.getFormData('bdc2').post[0].id
            }
            if (questionId) {
                formObject.id_question = questionId
            }
            if (responseId) {
                formObject.id_rep = responseId
            }
            return await apiService.post('getquizz', formObject)
        },

        setMessage(message, delay = 1500, bot = true, callbackFunc = null, step = null, stepIndex = null) {
            this.messages.push({
                id: this.makeId(),
                groupId: this.lastResponse.groupId,
                bot: bot,
                content: message,
                delay: delay,
                callbackFunc: callbackFunc,
                callback: !bot,
                show: false,
                step: step,
                stepIndex: stepIndex
            })
        },

        setQuestion(question, content = null) {
            this.messages.push({
                id: this.makeId(),
                groupId: this.lastResponse.groupId,
                bot: true,
                content: question && question.libelle ? question.libelle : null,
                callback: true,
                delay: this.botDelay,
                show: false
            })
        },

        setReponses(reponses, question) {
            reponses.forEach((reponse, index) => {
                this.messages.push({
                    id: this.makeId(),
                    groupId: this.lastResponse.groupId,
                    bot: false,
                    content: reponse.libelle,
                    data: {
                        question: question,
                        reponse: reponse,
                    },
                    step: reponse.step,
                    stepIndex: reponse.stepIndex,
                    callback: true,
                    delay: 0,
                    show: false
                })
            })
        },

        async callbackMessage(currentMsg) {
            // Can't call anytime the same response
            if (!currentMsg.callback) {
                return
            } else {
                currentMsg.callback = false
            }

            // Delete other response
            this.messages = this.messages.filter(message => (message.bot || (!message.bot && ((message.groupId != currentMsg.groupId) || (message.groupId == currentMsg.groupId && message.id == currentMsg.id)))));
            
            // Get next question
            let questionId, responseId;
            if (currentMsg.data) {
                questionId = currentMsg.data.question.id
                responseId = currentMsg.data.reponse.id
            }
            let response = await this.getQuestion(questionId, responseId)
            this.lastResponse = response.data.posts.post
        },

        async solutionFoundCloseForm(currentMsg) {
            if (currentMsg) {
                // Can't call anytime the same response
                if (!currentMsg.callback) {
                    return
                } else {
                    currentMsg.callback = false
                }

                // Save solution found
                let response = await apiService.post('quizz_valid', {
                    id_conso: this.$crypto.decrypt(localStorage.getItem('client_id')),
                    id_app: this.$formTool.getFormData('device')[0].value.id
                })

                if (response.data.posts.post != 1) {
                    this.$toast.error('Une erreur est survenue')
                    return
                }

                // Delete other response
                this.messages = this.messages.filter(message => (message.bot || (!message.bot && ((message.groupId != currentMsg.groupId) || (message.groupId == currentMsg.groupId && message.id == currentMsg.id)))));
                this.setMessage(this.$t('form.tchat.nous_sommes_ravies_que_vous_ailliez_trouve_une_solution_a_bientot'), 0)
                this.end({next: 'end-form'})
            }
        },

        solutionNotFound(currentMsg) {
            if (currentMsg) {
                // Can't call anytime the same response
                if (!currentMsg.callback) {
                    return
                } else {
                    currentMsg.callback = false
                }

                // Delete other response
                this.messages = this.messages.filter(message => (message.bot || (!message.bot && ((message.groupId != currentMsg.groupId) || (message.groupId == currentMsg.groupId && message.id == currentMsg.id)))));
                if (this.lastResponse.question.length <= 0) {
                    this.setMessage(this.$t('form.tchat.aucune_solution_n_a_ete_trouve_merci_de_continuer_le_formulaire'))
                    this.setMessage(this.$t('form.tchat.continuer_le_formulaire'), 0, false, this.goToNextBlock, this.responseStep, 0)
                } else {
                    this.setQuestion(this.lastResponse[0])
                    this.setReponses(this.lastResponse.reponses, value.question[0])
                }
            }
        },

        lastMessagesAndEnd() {
            this.setMessage(this.$t('form.tchat.aucune_solution_n_a_ete_trouve_merci_de_continuer_le_formulaire'))
            this.setMessage(this.$t('form.tchat.continuer_le_formulaire'), 0, false, this.goToNextBlock)
            this.messages[this.messages.length - 1].step = this.responseStep
            this.messages[this.messages.length - 1].stepIndex = 0
            this.responseStep
        },

        goToNextBlock(currentMsg) {
            if (currentMsg) {
                if (!currentMsg.callback) {
                    return
                } else {
                    currentMsg.callback = false
                }
                this.end({next: this.$formTool.blockData(this.$options.name).next})
            }
        },

        resetTchat() {
            if (localStorage['form-data']) {
                this.initTchat()
                this.$formTool.removeFormData(this.$options.name);
                this.$emit('update', this.$options.name)
            }
        }
    },

    mounted() {
        this.init()
    }
}
</script>


<style lang="scss">
.typing-loader {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    animation: loading 1s linear infinite alternate;
}

@keyframes loading {
 0% {
  background-color: rgba(000, 000, 000, 1);
  box-shadow: 
		12px 0px 0px 0px rgba(000, 000, 000, 0.2), 
		24px 0px 0px 0px rgba(000, 000, 000, 0.2);
 }
 25% {
  background-color: rgba(000, 000, 000, 0.4);
  box-shadow: 
		12px 0px 0px 0px rgba(000, 000, 000, 2), 
		24px 0px 0px 0px rgba(000, 000, 000, 0.2);
 }
 75% {
  background-color: rgba(000, 000, 000, 0.4);
  box-shadow: 
		12px 0px 0px 0px rgba(000, 000, 000, 0.2), 
		24px 0px 0px 0px rgba(000, 000, 000, 1);
 }
}
</style>



// WEBPACK FOOTER //
// src/processes/cards/tchat/OwnTchatCard2.vue